import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ETAPAS, COR_ORIGEM } from '../constantes';

// ⭐ Painel de favoritos da Home (só o Vagner vê a Home em blocos, e só ele
// tem este painel). Fica recolhido em toda visita; ao expandir, busca na hora
// as oportunidades favoritas do CRM em que ELE é o closer e as anotações
// favoritas dele. Barra recolhida fica limpa, sem contagem (decisão dele,
// 28/09/2026). Cada linha abre a tela de origem e a estrela tira do painel.

const token = () => localStorage.getItem('token');
const cab = () => ({ headers: { Authorization: `Bearer ${token()}` } });

function usuarioDoToken() {
  try {
    const p = JSON.parse(atob(token().split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return { id: p.id || p._id || '', nome: p.nome || localStorage.getItem('nomeUsuario') || '' };
  } catch { return { id: '', nome: localStorage.getItem('nomeUsuario') || '' }; }
}
const norm = (s) => String(s || '').trim().toLowerCase();

function idade(iso) {
  if (!iso) return '';
  const ms = Date.now() - new Date(iso).getTime();
  if (!Number.isFinite(ms) || ms < 0) return '';
  const min = Math.floor(ms / 60000), h = Math.floor(min / 60), d = Math.floor(h / 24);
  return min < 60 ? `${min}min` : h < 24 ? `${h}h` : d < 30 ? `${d}d` : `${Math.floor(d / 30)} m${d >= 60 ? 'eses' : 'ês'}`;
}
const fmtData = (iso) => { const d = new Date(iso); return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('pt-BR'); };
const semHtml = (html) => String(html || '').replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ').trim();

const estrela = { background: 'none', border: 'none', cursor: 'pointer', fontSize: 15, lineHeight: 1, padding: '0 2px', color: '#f59e0b' };
const chip = (cor, bg) => ({ background: bg || '#fff', color: cor, border: `1px solid ${cor}66`, borderRadius: 3, padding: '1px 6px', fontSize: 10.5, fontWeight: 700, whiteSpace: 'nowrap' });

export default function PainelFavoritos() {
  const navigate = useNavigate();
  const [aberto, setAberto] = useState(false);
  const [ops, setOps] = useState(null);
  const [notas, setNotas] = useState(null);
  const [erro, setErro] = useState('');
  const [copiado, setCopiado] = useState('');
  const eu = usuarioDoToken();

  const carregar = useCallback(async () => {
    setErro('');
    try {
      const [ro, rn] = await Promise.all([
        fetch('/oportunidades?favorita=1', cab()),
        fetch('/anotacoes?favorita=1', cab()),
      ]);
      const lo = ro.ok ? await ro.json() : [];
      const ln = rn.ok ? await rn.json() : [];
      // só as minhas: closer = eu (oportunidades) · usuario_id = eu (anotações)
      setOps((Array.isArray(lo) ? lo : []).filter(o => norm(o.closer) === norm(eu.nome)));
      setNotas((Array.isArray(ln) ? ln : []).filter(n => !eu.id || !n.usuario_id || n.usuario_id === eu.id));
    } catch (e) { setErro('Não consegui carregar os favoritos.'); setOps([]); setNotas([]); }
  }, [eu.nome, eu.id]);

  function alternar() {
    const v = !aberto;
    setAberto(v);
    if (v) { setOps(null); setNotas(null); carregar(); }
  }

  async function tirarOp(op) {
    setOps(l => (l || []).filter(o => o._id !== op._id));
    fetch(`/oportunidades/${op._id}/favorita`, { method: 'PUT', headers: { 'Content-Type': 'application/json', ...cab().headers }, body: JSON.stringify({ favorita: false }) }).catch(() => {});
  }
  async function tirarNota(n) {
    setNotas(l => (l || []).filter(x => x._id !== n._id));
    fetch(`/anotacoes/${n._id}/favorita`, { method: 'PUT', headers: { 'Content-Type': 'application/json', ...cab().headers }, body: JSON.stringify({ favorita: false }) }).catch(() => {});
  }
  function copiar(tel, id) {
    const digitos = String(tel || '').replace(/\D/g, '');
    navigator.clipboard?.writeText(digitos).then(() => { setCopiado(id); setTimeout(() => setCopiado(''), 1200); }).catch(() => {});
  }

  const etapaDe = (k) => ETAPAS.find(e => e.key === k) || { label: k || '—', cor: '#6b7280', bg: '#f9fafb' };

  return (
    <div style={{ width: '100%', maxWidth: 1100, background: '#f8fafc', border: '1px solid #e5e7eb', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.05)', overflow: 'hidden' }}>
      <button type="button" onClick={alternar}
        style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, background: 'none', border: 'none', padding: '10px 14px', cursor: 'pointer', textAlign: 'left' }}>
        <span style={{ fontSize: 11.5, fontWeight: 800, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.8 }}>⭐ Favoritos</span>
        <span style={{ fontSize: 11.5, fontWeight: 700, color: '#0a1628', background: '#fff', border: '1px solid #e5e7eb', borderRadius: 6, padding: '3px 10px' }}>
          {aberto ? 'Recolher ▴' : 'Mostrar ▾'}
        </span>
      </button>

      {aberto && (
        <div style={{ padding: '0 12px 12px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: 12 }}>
          {erro && <div style={{ gridColumn: '1 / -1', color: '#b91c1c', fontSize: 12 }}>{erro}</div>}

          {/* ── Oportunidades favoritas (closer = eu) ── */}
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '7px 10px', borderBottom: '1px solid #e5e7eb', background: '#fafafa' }}>
              <span style={{ fontSize: 12, fontWeight: 700, color: '#0a1628' }}>📋 Oportunidades favoritas{ops ? ` (${ops.length})` : ''}</span>
              <button type="button" onClick={() => navigate('/crm')} style={{ background: 'none', border: 'none', color: '#0369a1', fontSize: 11, fontWeight: 600, cursor: 'pointer' }}>abrir CRM →</button>
            </div>
            {ops === null ? <div style={{ padding: 12, fontSize: 12, color: '#9ca3af' }}>Carregando…</div>
              : ops.length === 0 ? <div style={{ padding: 14, fontSize: 12, color: '#9ca3af', textAlign: 'center' }}>Nenhuma oportunidade sua marcada com ⭐.</div>
              : ops.map(op => {
                const et = etapaDe(op.etapa); const origem = (op.origem_lead || '').trim(); const age = idade(op.criado_em);
                return (
                  <div key={op._id} onClick={() => navigate(`/crm?oportunidade=${op._id}`)} title="Abrir no CRM"
                    style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px', borderBottom: '1px solid #f3f4f6', cursor: 'pointer' }}
                    onMouseEnter={e => { e.currentTarget.style.background = '#f8fafc'; }} onMouseLeave={e => { e.currentTarget.style.background = ''; }}>
                    <button type="button" title="Tirar dos favoritos" onClick={e => { e.stopPropagation(); tirarOp(op); }} style={estrela}>⭐</button>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                        <span style={{ fontSize: 12.5, fontWeight: 700, color: '#0a1628', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 220 }}>{op.nome_cliente}</span>
                        <span style={chip(et.cor, et.bg)}>{et.label}</span>
                        {origem && <span style={chip(COR_ORIGEM[origem] || '#6b7280')}>{origem}</span>}
                        {age && <span style={{ fontSize: 10, color: '#9ca3af', fontWeight: 700 }} title={`Criada em ${fmtData(op.criado_em)}`}>{age}</span>}
                      </div>
                      <div style={{ fontSize: 11, color: '#6b7280', display: 'flex', alignItems: 'center', gap: 6, marginTop: 1 }}>
                        {op.telefone && (
                          <span onClick={e => { e.stopPropagation(); copiar(op.telefone, op._id); }} title="Copiar número" style={{ cursor: 'copy', color: '#15803d', fontWeight: 600 }}>
                            {op.telefone} {copiado === op._id ? '✓' : '📋'}
                          </span>
                        )}
                        {op.observacao && <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>· {op.observacao}</span>}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>

          {/* ── Anotações favoritas (minhas) ── */}
          <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '7px 10px', borderBottom: '1px solid #e5e7eb', background: '#fafafa' }}>
              <span style={{ fontSize: 12, fontWeight: 700, color: '#0a1628' }}>📝 Anotações favoritas{notas ? ` (${notas.length})` : ''}</span>
              <button type="button" onClick={() => navigate('/anotacoes')} style={{ background: 'none', border: 'none', color: '#0369a1', fontSize: 11, fontWeight: 600, cursor: 'pointer' }}>abrir anotações →</button>
            </div>
            {notas === null ? <div style={{ padding: 12, fontSize: 12, color: '#9ca3af' }}>Carregando…</div>
              : notas.length === 0 ? <div style={{ padding: 14, fontSize: 12, color: '#9ca3af', textAlign: 'center' }}>Nenhuma anotação sua marcada com ⭐. Marque pela estrela na página Anotações.</div>
              : notas.map(n => {
                const resumo = semHtml(n.conteudo).slice(0, 140);
                return (
                  <div key={n._id} onClick={() => navigate(`/anotacoes?nota=${n._id}`)} title="Abrir a anotação"
                    style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '6px 10px', borderBottom: '1px solid #f3f4f6', cursor: 'pointer' }}
                    onMouseEnter={e => { e.currentTarget.style.background = '#f8fafc'; }} onMouseLeave={e => { e.currentTarget.style.background = ''; }}>
                    <button type="button" title="Tirar dos favoritos" onClick={e => { e.stopPropagation(); tirarNota(n); }} style={estrela}>⭐</button>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                        <span style={{ fontSize: 12.5, fontWeight: 700, color: '#0a1628', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{n.titulo || 'Sem título'}</span>
                        <span style={{ fontSize: 10, color: '#9ca3af', whiteSpace: 'nowrap' }}>{fmtData(n.atualizado_em || n.criado_em)}</span>
                      </div>
                      {resumo && <div style={{ fontSize: 11, color: '#6b7280', overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{resumo}</div>}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
}
